import { Uuid } from "../../../domain/model/uuid/uuid.type";
import { SyncStoreAnimalWeight } from "../model/sync-store-animal-weight";
import { SyncStoreLastServerSyncInfo } from "../model/sync-store-last-server-sync-info";
import { SyncStoreUpdateTypeEnum } from "../sync-store-enums";
import { SyncStoreUpdateData } from "../sync-store-update-data";

export class SyncStoreUpdateAnimalWeighing implements SyncStoreUpdateData {

  readonly updateType: SyncStoreUpdateTypeEnum = SyncStoreUpdateTypeEnum.Update;

  constructor(
    readonly id: Uuid,
    readonly lastKnownServerUpdate: SyncStoreLastServerSyncInfo,
    readonly batchWeighingId: Uuid,
    readonly batchId: Uuid,
    readonly sectionId: Uuid,
    readonly animalWeight: SyncStoreAnimalWeight
  ) {}
}
